import React, {ReactNode} from 'react';
import {useOidcUser} from "./OidcUserProvider";
import {CenteredCircularProgress} from "../../components/progress/CenteredCircularProgress";

/**
 * Renders any child components only when the user is authenticated.
 * Will trigger authentication flow when necessary.
 */
export function RequireAuthentication(props: {
  children?: ReactNode;
}) {
  const user = useOidcUser();
  // console.log("RequireAuthentication: user: ", user);

  return <>
    {(!user || user.expired) && <CenteredCircularProgress loadingText={"Loading user or query info"} />}
    {(user && !user.expired) && props.children}
  </>;
}
